/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0MissingworkentryDeleteByIdsDelete } from '../fn/missing-work-entry/api-v-0-missingworkentry-delete-by-ids-delete';
import { ApiV0MissingworkentryDeleteByIdsDelete$Params } from '../fn/missing-work-entry/api-v-0-missingworkentry-delete-by-ids-delete';
import { apiV0MissingworkentryGetByCompanyGet$Json } from '../fn/missing-work-entry/api-v-0-missingworkentry-get-by-company-get-json';
import { ApiV0MissingworkentryGetByCompanyGet$Json$Params } from '../fn/missing-work-entry/api-v-0-missingworkentry-get-by-company-get-json';
import { apiV0MissingworkentryGetByCompanyGet$Plain } from '../fn/missing-work-entry/api-v-0-missingworkentry-get-by-company-get-plain';
import { ApiV0MissingworkentryGetByCompanyGet$Plain$Params } from '../fn/missing-work-entry/api-v-0-missingworkentry-get-by-company-get-plain';
import { MissingWorkEntry } from '../models/missing-work-entry';

@Injectable({ providedIn: 'root' })
export class MissingWorkEntryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0MissingworkentryGetByCompanyGet()` */
  static readonly ApiV0MissingworkentryGetByCompanyGetPath = '/api/v0/missingworkentry/getByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MissingworkentryGetByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MissingworkentryGetByCompanyGet$Plain$Response(params?: ApiV0MissingworkentryGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MissingWorkEntry>>> {
    const obs = apiV0MissingworkentryGetByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MissingworkentryGetByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MissingworkentryGetByCompanyGet$Plain(params?: ApiV0MissingworkentryGetByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<MissingWorkEntry>> {
    const resp = this.apiV0MissingworkentryGetByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<MissingWorkEntry>>): Array<MissingWorkEntry> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MissingworkentryGetByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MissingworkentryGetByCompanyGet$Json$Response(params?: ApiV0MissingworkentryGetByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MissingWorkEntry>>> {
    const obs = apiV0MissingworkentryGetByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MissingworkentryGetByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0MissingworkentryGetByCompanyGet$Json(params?: ApiV0MissingworkentryGetByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<MissingWorkEntry>> {
    const resp = this.apiV0MissingworkentryGetByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<MissingWorkEntry>>): Array<MissingWorkEntry> => r.body)
    );
  }

  /** Path part for operation `apiV0MissingworkentryDeleteByIdsDelete()` */
  static readonly ApiV0MissingworkentryDeleteByIdsDeletePath = '/api/v0/missingworkentry/deleteByIds';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0MissingworkentryDeleteByIdsDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MissingworkentryDeleteByIdsDelete$Response(params?: ApiV0MissingworkentryDeleteByIdsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0MissingworkentryDeleteByIdsDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0MissingworkentryDeleteByIdsDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0MissingworkentryDeleteByIdsDelete(params?: ApiV0MissingworkentryDeleteByIdsDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0MissingworkentryDeleteByIdsDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
